"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeprecatedId = exports.parseDeprecatedId = void 0;
function parseDeprecatedId(value) {
    const parsedValue = Number.parseInt(value);
    if (!Number.isNaN(parsedValue) && Number.isFinite(parsedValue) && parsedValue.toString() === value) {
        return parsedValue;
    }
    return value;
}
exports.parseDeprecatedId = parseDeprecatedId;
const isDeprecatedId = (id) => {
    return typeof id === "number";
};
exports.isDeprecatedId = isDeprecatedId;
